// extracted by mini-css-extract-plugin
export default {"employeeTransactions":"tUTiJR8xqR53cSYpqeZI"};